export const COLORS = {
  grayscaleBlack: '#07142A',
  grayscaleWhite: '#FFFFFF',
};
